/* eslint-disable max-lines, init-declarations, no-shadow, no-warning-comments, camelcase */

import * as React from "react";
import {setDisplayNewTierNotification, setPostPurchaseModal} from "../../../actions";
import {shineCreditUsed, shoppingCreditUsed, totalCreditUsed} from "../modules/CustomerCreditsHelper";
import AnalyticsHelper from "../../../shared/modules/AnalyticsHelper";
import Helper from "../../../shared/modules/Helper";
import Modal from "react-bootstrap-modal";
import MovableIncHelper from "../../../shared/modules/MovableIncHelper";
import OrderAPI from "../modules/OrderAPI";
import PropTypes from "prop-types";
import {connect} from "react-redux";
class CheckoutModal extends React.PureComponent {

  static propTypes = {
    "apiToken": PropTypes.string.isRequired,
    "customerCredits": PropTypes.object.isRequired,
    "customerId": PropTypes.string.isRequired,
    "onCloseModal": PropTypes.func.isRequired,
    "open": PropTypes.bool.isRequired,
    "parentProps": PropTypes.object.isRequired,
    "pdOrderInfo": PropTypes.object.isRequired,
    "setDisplayNewTierNotification": PropTypes.func.isRequired,
    "setPostPurchaseModal": PropTypes.func.isRequired,
    "warehouseClosed": PropTypes.bool,
    "warehouseClosedShopPageText": PropTypes.string
  };

  static defaultProps = {
    "customerCredits": {
      "shine": 0,
      "shopping": 0
    },
    "warehouseClosed": false,
    "warehouseClosedShopPageText": null
  };

  constructor (props) {
    super(props);

    this.state = {
      "buttonText": "Place Order",
      "isPurchasing": false,
      "purchaseComplete": false,
      "subtotalText": "Subtotal"
    };
  }

  componentDidMount () {
    const {apiToken} = this.props;

    OrderAPI.setApiToken(apiToken);
  }

  componentDidUpdate (prevProps) {
    const {parentProps, open} = this.props;
    const {productDescriptor} = parentProps;
    if (prevProps.open !== open) {
      AnalyticsHelper.sendProductAddedToCartEvent(productDescriptor);
    }
  }

  handlePurchaseResult = (selector) => {
    // TODO: React-ify this
    $(".btn-primary.center").attr("disabled", false);
    if ($(".summary-review").is(":visible")) {
      $(`.summary-review, ${selector}`).slideToggle();
      if ($(".summary-title").is(":visible")) {
        $(".summary-title").slideToggle();
      }
    } else {
      $(".summary-review, .purchase-failure").slideToggle();
    }
    $(".summary").animate({
      "height": "111px",
      "margin-top": "32px"
    });
  }

  handleSuccessfulPurchase = (response) => {
    const {
      customerId,
      "pdOrderInfo": {
        "store_kind_name": storeKindName,
        "product_descriptor_id": productDescriptorId,
        "price": productPrice
      },
      setDisplayNewTierNotification,
      setPostPurchaseModal
    } = this.props;

    this.setState(
      {
        "buttonText": response.message,
        "isPurchasing": false,
        "purchaseComplete": true,
        "subtotalText": "Total"
      },
      this.handlePurchaseResult(".purchase-success")
    );

    setPostPurchaseModal(response.post_purchase_promo);
    setDisplayNewTierNotification(response.show_new_tier_notification);

    const totalForConversionStat = response.price_dollars;
    const productName = response.product_name;
    const purchasedProducts = [
      {
        "member_price": productPrice,
        "name": productName,
        "product_descriptor_id": productDescriptorId,
        "product_descriptor_sku": response.pd_sku
      }
    ];

    MovableIncHelper.sendMovableIncConversion(purchasedProducts, totalForConversionStat, null, storeKindName);

    window.analytics.track("Shop: Purchased Piece", {
      "store_kind": storeKindName,
      "user_id": customerId
    });
  }

  handleUnsuccessfulPurchase = (error) => {
    const {
      customerId,
      "pdOrderInfo": {"store_kind_name": storeKindName}
    } = this.props;
    let message;
    this.setState({"buttonText": error.message});

    if (error.reason === "bad-card") {
      this.handlePurchaseResult(".purchase-failure");
      message = "Shop: Purchase Failure";
    } else if (error.reason === "no-more") {
      this.handlePurchaseResult(".purchase-no-more");
      message = "Shop: Out of Stock";
    } else if (error.reason === "system-failure") {
      this.handlePurchaseResult(".system-failure");
      message = "Shop: Purchasing Failure";
    } else if (error.reason === "too-soon") {
      this.handlePurchaseResult(".too-soon");
      message = "Shop: Too Soon";
    }

    window.analytics.track(message, {
      "store_kind": storeKindName,
      "user_id": customerId
    });
  }

  clickHandler = () => {
    const {"pdOrderInfo": {"store_kind_name": storeKindName}} = this.props;
    const {purchaseComplete} = this.state;

    if (purchaseComplete) {
      window.location.href = storeKindName === "clearance" ? "/shop/clearance" : "/jewelry";
    } else {
      this.handleOrderPurchase();
    }
  }

  handleOrderPurchase = () => {
    const {
      customerId,
      "pdOrderInfo": {
        "product_descriptor_id": productDescriptorId,
        "store_kind": storeKind
      }
    } = this.props;

    /* eslint-disable no-undef */
    const purchaseInfo = {
      "campaign_id": getCookie("campaign_id"),
      "product_descriptor_id": productDescriptorId,
      "store_kind": storeKind,
      "template_id": getCookie("template_id"),
      "user_id": customerId
    };
    /* eslint-enable no-undef */

    this.setState(
      {
        "buttonText": "Purchasing...",
        "isPurchasing": true
      },
      () => {
        const response = OrderAPI.purchaseOrder(purchaseInfo);

        response.then((data) => {
          if (data.status === 200) {
            this.handleSuccessfulPurchase(data);
          } else {
            this.handleUnsuccessfulPurchase(data);
          }
        });
      }
    );
  }

  render () {
    const {
      customerCredits,
      onCloseModal,
      open,
      "pdOrderInfo": {
        "address_on_file": {
          city,
          "first_name": firstName,
          "last_name": lastName,
          state,
          "street_address_1": streetAddress1,
          "street_address_2": streetAddress2,
          zip
        },
        "billing_info_type": billingInfoType,
        "card_on_file": cardOnFile,
        price,
        "price_class": priceClass,
        "price_description": priceDescription,
        "store_kind": storeKind,
        "store_kind_name": storeKindName,
        "rewards_info": {
          "discounts": rewardsDiscount,
          "invoice_label": rewardsInvoiceLabel
        }
      },
      "parentProps": {
        customerId,
        "productDescriptor": {
          "details": {
            "designer": designerName,
            "formatted_ring_size": formattedRingSize,
            "full_size_urls": fullSizeUrls,
            "kind_name": kindName,
            name
          },
          id
        }
      },
      warehouseClosed,
      warehouseClosedShopPageText
    } = this.props;
    const {
      buttonText,
      isPurchasing,
      subtotalText
    } = this.state;
    const returnTo = window.location.pathname;

    return (
      <Modal
        className="confirm-content"
        id="confirm-purchase-modal"
        onHide={onCloseModal}
        show={open}
      >
        <Modal.Header
          className="summary"
          closeButton
        >
          <Modal.Title className="summary-review">
            Order Summary
          </Modal.Title>
          <div className="purchase-result purchase-success">
            <div className="success-message-desktop">
              Great Choice! Enjoy Your Purchase!
            </div>
            <div className="success-message-mobile">
              Congratulations!
            </div>
            <div className="success-confirmation">
              Expect an email confirmation shortly.
            </div>
          </div>
          <div className="purchase-result purchase-failure">
            <div className="failure-message">
              Order Unsuccessful
            </div>
            <div className="failure-reason">
              Sorry, we can&apos;t complete this payment.
              {" "}
              <a
                href={`/account/billing?return_to=${returnTo}`}
                id="updateCardLink"
              >
                Update Card
              </a>
            </div>
          </div>
          <div className="purchase-result system-failure">
            <div className="failure-message">
              Oh no, something went wrong!
            </div>
            <div className="failure-reason">
              Sorry, we can&apos;t complete this payment.
            </div>
          </div>
          <div className="purchase-result too-soon">
            <div className="failure-message">
              Order Unsuccessful
            </div>
            <div className="failure-reason">
              Please wait a few minutes and try again.
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="container-fluid">
          {
            warehouseClosed &&
            warehouseClosedShopPageText &&
            <div className="row">
              <div className="warehouse-closure color-secondary-bg">
                {warehouseClosedShopPageText}
              </div>
            </div>
          }
          <div className="row">
            <div className="details col-xs-12 col-sm-8">
              <div className="row">
                <div className="item-img col-xs-4 col-sm-6">
                  <img src={fullSizeUrls[0]} />
                </div>
                <div className="product-details col-xs-8 col-sm-6 pbl">
                  <h6 className="left">
                    {designerName}
                  </h6>
                  <p className="left mtn mln mbn">
                    {name}
                  </p>
                  {kindName === "Ring" &&
                    <div>
                      {`Size: ${formattedRingSize}`}
                    </div>}
                </div>
                <div className="purchasing-details col-xs-12 col-sm-6">
                  <div className={priceClass}>
                    {priceDescription}
                    <span>
                      {`$${Helper.formatPriceCents(price)}`}
                    </span>
                  </div>
                  {rewardsDiscount > 0 &&
                    <div className={`${priceClass} rewards-discount`}>
                      {rewardsInvoiceLabel}
                      <span>
                        {`-$${Helper.formatPriceCents(rewardsDiscount)}`}
                      </span>
                    </div>
                  }
                  {storeKindName === "clearance"
                    ? <div className="credit-applies bold">
                      Credit does not apply.
                    </div> // eslint-disable-line react/jsx-closing-tag-location
                    : <React.Fragment>
                      {shineCreditUsed(price, rewardsDiscount, customerCredits) > 0 &&
                        <div className={`${priceClass} rewards-discount`}>
                          Monthly Credit
                          <span>
                            {`-$${Helper.formatPriceCents(shineCreditUsed(price, rewardsDiscount, customerCredits))}`}
                          </span>
                        </div>
                      }
                      {shoppingCreditUsed(price, rewardsDiscount, customerCredits) > 0 &&
                        <div className={`${priceClass} rewards-discount`}>
                          Shopping Credit
                          <span>
                            {`-$${Helper.formatPriceCents(shoppingCreditUsed(
                              price, rewardsDiscount, customerCredits
                            ))}`}
                          </span>
                        </div>
                      }
                    </React.Fragment> // eslint-disable-line react/jsx-closing-tag-location
                  }
                  <div className="shipping-handling">
                    Shipping & Handling
                    {" "}
                    <span>
                      Free
                    </span>
                  </div>
                  <div className="subtotal bold">
                    {subtotalText}
                    {" "}
                    <span>
                      {`$${Helper.formatPriceCents(price - rewardsDiscount -
                        (storeKindName === "clearance" ? 0
                          : totalCreditUsed(price, rewardsDiscount, customerCredits)))}`}
                    </span>
                  </div>
                  <div className="tax-applies small">
                    * Sales tax may apply
                  </div>
                </div>
                <div className="place-order col-xs-12">
                  <button
                    className="btn btn-primary center"
                    data-customer={customerId}
                    data-product-descriptor={id}
                    data-store-kind={storeKind}
                    data-store-kind-name={storeKindName}
                    disabled={isPurchasing}
                    onClick={this.clickHandler}
                    type="button"
                  >
                    <span>
                      {buttonText}
                    </span>
                    <span>
                      ...
                    </span>
                  </button>
                </div>
                <div className="credit-tax-note col-xs-12">
                  * Final invoice will include tax where applicable.
                </div>
              </div>
            </div>
            <div className="billing-shipping-details col-xs-12 col-sm-4">
              <h6 className="left">
                Billing & Shipping
              </h6>
              <div className="billing-info">
                {billingInfoType === "credit_card" && cardOnFile &&
                  <div className="billing-statement">
                    Purchases will be charged on your card ending in
                    {" "}
                    <span>
                      {cardOnFile}
                    </span>
                  </div>}
                {billingInfoType === "apple_pay" &&
                  <div className="billing-statement">
                    Purchases will be charged to your Apple Pay account
                  </div>}
                {!cardOnFile && "Purchases will be charged to your card on file."}
                <div className="billing-change underline">
                  <a href={`/account/billing?return_to=${returnTo}`}>
                    Change
                  </a>
                </div>
              </div>
              <div className="shipping-info">
                <div className="shipping-name">
                  {firstName}
                  &nbsp;
                  {lastName}
                </div>
                <div className="shipping-address-line-1">
                  {streetAddress1}
                  &nbsp;
                  {streetAddress2}
                </div>
                <div className="shipping-address-line-2">
                  {city}
                  ,&nbsp;
                  {state}
                  &nbsp;
                  {zip}
                </div>
                <div className="shipping-change underline">
                  <a href={`/account/shipping?return_to=${returnTo}`}>
                    Change
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStoreToProps = store => ({"customerCredits": store.customerCredits});

export default connect(
  mapStoreToProps,
  {
    setDisplayNewTierNotification,
    setPostPurchaseModal
  }
)(CheckoutModal);
